import apiConfig from "../config";
import axios from "axios";

const createEnquery = async (enqueryData) => {
    try {
        const response = await axios.post(`${apiConfig.apiUrl}/Enquery/Create`, enqueryData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating enquery:", error);
        return null;
    }
};

export { createEnquery };
